var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"vraag w100 clearfix",class:[_vm.error ? 'error-recaptcha' : '']},[_c('vue-recaptcha',{ref:"recaptcha",attrs:{"sitekey":_vm.sitekey},on:{"loaded":_vm.onLoaded}}),_c('div',{staticClass:"error-tooltip"},[_c('span',[_vm._v(_vm._s(_vm.error))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }